import React from "react";
import cn from "classnames";

import './style.css'

class Sector extends React.Component {
  static defaultProps = {
    sectors: [],
  }

  refScroll = (ref) => {
    setTimeout(() => {
      if (ref) {
        ref.scrollIntoView({block: "center", behavior: "smooth"});
      }
    }, 0)
  }

  render() {
    const {sectors, target, selected, active, disabled} = this.props
    const score = sectors.reduce((score, shot) => {
      if (shot.length) score += shot[0] * shot[1]
      return score
    }, 0)
    return (
      <div className={cn('sector', {
        '-interactive': active && !disabled,
        // 'sector-completed': completed
      })} ref={selected ? this.refScroll : null}>
        <div className={cn('sector-close_1', {
          '-active': score >= target
        })}/>
        <div className={cn('sector-close_2', {
          '-active': score >= target * 2
        })}/>
        <div className={cn('sector-close_3', {
          '-active': score >= target * 3
        })}/>
      </div>
    );
  }
}

export default Sector